import {
  DataAnalyticsTaggingErrorCode,
  DataAnalyticsTaggingEventType,
  DataAnalyticsTaggingEvents
} from '@tdwb/core'
import { W8benFormAnalytics } from '@tdwb/lazy/w8ben-form';
import { EservicesAnalytics } from './modules/eservices/eservices.analytics';
import { TransfersAnalytics } from './modules/transfers/transfers.analytics';
import { TradingAnalytics } from './modules/trading/trading.analytics';
import { UserProfileAnalytics } from './modules/user-profile/user-profile.analytics';
import { LtiAnalytics } from './modules/lti/lti.analytics';
import { LearnAnalytics } from './modules/learn/learn.analytics';
import { IntegrationAnalytics } from './modules/platform/integration/integration.analytics';
import { AccountsAnalytics } from './modules/accounts/accounts.analytics';
import { WebbrokerGamlAttestationAnalytics } from './modules/gaml-attestation/gaml-attestation.analytics';

export class WebbrokerDataAnalyticsTaggingConstants {
  static taggingEvents: DataAnalyticsTaggingEvents = {
    pageHomeSummary: {
      event: DataAnalyticsTaggingEventType.PAGE_LOAD,
      page: {
        name: 'summary',
        section: 'wbt',
        subSection1: 'home',
        subSection2: 'summary',
        customPageName: 'wb_home-summary'
      }
    },
    // eslint-disable-next-line @typescript-eslint/naming-convention
    modalHome_Market_News: {
      event: DataAnalyticsTaggingEventType.PAGE_CHANGE,
      page: {
        modalName: 'market updates',
        subSection1: 'home',
        subSection2: 'summary',
        customPageName: 'wb_modal-market-updates'
      }
    },
    modalMessages: {
      event: DataAnalyticsTaggingEventType.PAGE_CHANGE,
      page: {
        modalName: 'important messages',
        subSection1: 'home',
        subSection2: 'summary',
        customPageName: 'wb_modal-important-messages'
      }
    },
    modalSearch: {
      event: DataAnalyticsTaggingEventType.PAGE_CHANGE,
      page: {
        modalName: 'search',
        subSection1: 'modal',
        subSection2: 'search',
        customPageName: 'wb_modal-search'
      }
    },
    error404: {
      event: DataAnalyticsTaggingEventType.ERROR,
      page: {
        name: 'td-wb-error-404',
        subSection: 'error'
      },
      error: {
        code: DataAnalyticsTaggingErrorCode.ERROR_404_CODE,
        message: 'Sorry, the page you\'re looking for isn\'t here.'
      }
    }
  }

  static dataAnalyticsTaggingEventArr: Array<DataAnalyticsTaggingEvents> = [
    EservicesAnalytics.taggingEvents,
    TransfersAnalytics.taggingEvents,
    TradingAnalytics.taggingEvents,
    UserProfileAnalytics.taggingEvents,
    LtiAnalytics.taggingEvents,
    LearnAnalytics.taggingEvents,
    IntegrationAnalytics.taggingEvents,
    AccountsAnalytics.taggingEvents,
    W8benFormAnalytics.taggingEvents,
    this.taggingEvents
  ]
}

export {
  WebbrokerGamlAttestationAnalytics
}